import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { Modal } from 'antd';

interface ConfirmModalProps {
	title: string;
	message?: string;
	onHide: () => void;
	onConfirm: (state?: any) => void;
	t: (key: string) => string;
	children?: React.ReactNode;
}

export class ConfirmModal extends Component<ConfirmModalProps> {
	componentDidMount() {
		// Ajouter l'écouteur d'événements pour la touche Entrée
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		// Nettoyer l'écouteur d'événements
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (event: KeyboardEvent) => {
		// Vérifier si la touche Entrée est pressée
		if (event.key === 'Enter') {
			// Empêcher le comportement par défaut
			event.preventDefault();

			// Vérifier que l'événement ne provient pas d'un champ de saisie
			const target = event.target as HTMLElement;
			if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.contentEditable === 'true')) {
				return;
			}

			// Valider la modal
			this.props.onHide();
			this.props.onConfirm(this.state);
		}
	}

	render() {
		return (
			<Modal
				onOk={() => {
					this.props.onHide();
					this.props.onConfirm(this.state);
				}}
				open={true}
				maskClosable={false}
				title={
					this.props.t
						? this.props.t(this.props.title)
						: this.props.title
				}
				onCancel={this.props.onHide}
				okButtonProps={{ 'data-testid': 'confirm-modal-button' } as any}
				cancelButtonProps={{ 'data-testid': 'cancel-modal-button' } as any}
			>
				{this.props.children || (this.props.message ? <div style={{ whiteSpace: 'pre-line' }}>{this.props.t(this.props.message)}</div> : '')}
			</Modal>
		);
	}
}

// PropTypes supprimés car nous utilisons TypeScript

export default withTranslation()(ConfirmModal);
